/*
 * Thunderstorm is a full web app framework!
 *
 * Typescript & Express backend infrastructure that natively runs on firebase function
 * Typescript & React frontend infrastructure
 *
 * Copyright (C) 2020 Adam van der Kruk aka TacB0sS
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import { Module } from '@nu-art/ts-common';
// noinspection TypeScriptPreferShortImport
import { ModuleFE_XHR } from '../http/ModuleFE_XHR.js';
import { ModuleFE_RoutingV2 } from '../routing/ModuleFE_RoutingV2.js';
import { HttpMethod } from '@nu-art/thunderstorm-shared';
export class PageLoadingModule_Class extends Module {
    injected = {};
    loadScript(src, progressListener) {
        const apiDef = {
            method: HttpMethod.GET,
            baseUrl: ModuleFE_RoutingV2.getOrigin(),
            path: src
        };
        ModuleFE_XHR
            .createRequest(apiDef)
            .setOnProgressListener((ev) => {
            const progress = ev.loaded / ev.total;
            progressListener(progress);
        })
            .execute(response => {
            const divElement = document.createElement('script');
            // divElement.innerHTML = response;
            divElement.id = src;
            divElement.async = true;
            this.injected[src] = divElement;
        });
    }
    getNode(src) {
        return this.injected[src];
    }
}
export const EntryComponentLoadingModule = new PageLoadingModule_Class();
//# sourceMappingURL=entry-component-loading-module.js.map